import { render, staticRenderFns } from "./fund-welfare.vue?vue&type=template&id=7e20e3d0&scoped=true&"
import script from "./fund-welfare.vue?vue&type=script&lang=js&"
export * from "./fund-welfare.vue?vue&type=script&lang=js&"
import style0 from "./fund-welfare.vue?vue&type=style&index=0&id=7e20e3d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20e3d0",
  null
  
)

export default component.exports